<template>
  <custom-dialog :title="$t('dms_publish_record_dialog.fa_bu_ji_lu')" width="1500px" :visible="visible" v-on="$listeners" class="publish-record-dialog" :append-to-body="true">
    <div class="dialog-body">
      <div class="box-content">
        <div class="publish-record content">
          <!-- <div class="search-hd">
            <el-form
              :inline="true"
              @submit.native.prevent
            >
              <el-form-item>
                <el-button
                  :disabled="!selectData.length"
                  @click="batchPublishVersion"
                >
                  <i class="icon icon-fabu"></i>
                  {{ $t('page_protocol_pi_liang_fa_bu') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div> -->
          <div class="table-bd">
            <custom-table
              height="100%"
              :index="true"
              :data="publishRecord"
              tableCode="protocol_publish_record"
              @sort="sortChange"
              @filter="filterChange"
              :slots="['action']"
              @on-row-click="onRowClick"
              type="checkbox"
              v-model="selectData"
            >
              <template v-slot:action="scope">
                <el-button type="text" size="mini" @click.stop="delPublishRecord(scope.row)">{{ $t('Common.com_delete') }}</el-button>
                <el-button type="text" size="mini" @click.stop="republishPublishRecord(scope.row)">{{ $t('dms_publish_record_dialog.chong_xin_fa_bu') }}</el-button>
              </template>
            </custom-table>
          </div>
        </div>
        <div class="topic-info content">
          <div class="search-hd">
            <el-form :inline="true" @submit.native.prevent class="mr-0" style="float: right">
              <el-form-item>
                <search-input v-model="formSearch.keyword" :placeholder="$t('dms_publish_record_dialog.TopicmcTopbmTopicURL')" @fetch="onPageChange({ page: 1 })"></search-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="table-bd">
            <custom-table height="100%" :index="true" :data="topicMsg" tableCode="protocol_topic_msg" @sort="sortChange" @filter="filterChange" :slots="['topicName', 'topicCode']">
              <template v-slot:topicName="scope">
                <span class="topic-name href" @click="onDetail(scope.row.topicId)">{{ scope.row.topicName }}</span>
              </template>
              <template v-slot:topicCode="scope">
                <span class="topic-code href" @click="checkRelativeModelDetail(scope.row)">{{ scope.row.topicCode }}</span>
              </template>
            </custom-table>
          </div>
          <div class="table-page">
            <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
    </div>
    <topic-detail-drawer v-if="showTopicDetailDialog" :visible.sync="showTopicDetailDialog" :id="curTopicId"></topic-detail-drawer>
    <!-- 查看关联物模型 -->
    <check-relative-model-dialog v-if="showCheckRelativeModelDialog" @close="showCheckRelativeModelDialog = false" :model="dialogModel4" :protocolCode="protocolCode"></check-relative-model-dialog>
    <!-- <batch-republish-version-dialog
      v-if="showPublishDialog"
      @close="showPublishDialog=false"
      :model="publishModel"
      @success="onRepublishSuccess"
    ></batch-republish-version-dialog> -->
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';
import topicDetailDrawer from './topic_detail_drawer.vue';
import checkRelativeModelDialog from './check_relative_model_dialog.vue';
// import batchRepublishVersionDialog from './batch_republish_version_dialog.vue';

export default {
  name: 'publishRecordDialog',
  mixins: [dialogMixins],
  components: {
    // selClassifyDialog,
    // topicBindModelDialog
    topicDetailDrawer,
    checkRelativeModelDialog,
  },
  props: {
    protocolId: [String, Number],
    protocolCode: String,
  },
  data() {
    return {
      publishRecord: [],
      editModel: {},
      formSearch: {
        keyword: '',
        orderType: '',
        orderBy: '',
        pageSize: 20,
        pageNum: 1,
      },
      totalRows: null,
      topicMsg: [],
      showTopicImportDialog: false,
      showTopicImportDialogModel: {
        title: this.$t('dms_publish_record_dialog.Topicshe_zhi'),
      },
      showTopicBindDialog: false,
      dialogModel3: {},
      curTopicId: '',
      showTopicDetailDialog: false,

      showCheckRelativeModelDialog: false,
      dialogModel4: {},
      selectData: [],
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 批量发布
    // batchPublishVersion() {
    //   const list = this.selectData;
    //   const tips = `您确定要重新发布选中的${list.length}个协议吗？`;
    //   this.$showConfirm(tips).then(() => {
    //     this.publishModel = { data: list, title: '批量发布', };
    //     this.showPublishDialog = true;
    //   });
    // },
    checkRelativeModelDetail(row) {
      this.dialogModel4 = {
        data: row,
        title: this.$t('dms_publish_record_dialog.ckglwmx'),
      };
      this.showCheckRelativeModelDialog = true;
    },
    onDetail(id) {
      this.curTopicId = id;
      this.showTopicDetailDialog = true;
    },
    onBind(row) {
      this.editModel = row;
      this.dialogModel3 = {
        title: this.$t('dms_publish_record_dialog.glwmxo', [row.topicCode]),
      };
      this.showTopicBindDialog = true;
    },
    onRowClick(row) {
      this.editModel = row;

      this.getTopicMsg();
    },
    getPublishRecord() {
      // publishType 发布类型，1-TCP，2-TIM，3-TMM'
      this.$getJSON(`${apis.ProtocolPublishList}/${this.protocolId}`, {
        publishType: '1',
      }).then((res) => {
        // this.publishRecord = res.data.map(item => Object.assign({}, this.model.data, item));
        this.publishRecord = res.data;
        if (this.publishRecord.length) {
          this.editModel = this.publishRecord[0];
          this.getTopicMsg();
        }
      });
    },
    delPublishRecord(row) {
      const tips = this.$t('dms_publish_record_dialog.nqdyscxzdyfbxym');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.ProtocolPublishPublishDelete}/${row.publishId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.getPublishRecord();
        });
      });
    },
    republishPublishRecord(row) {
      const tips = this.$t('dms_publish_record_dialog.nqdycxfbxzdbboxym', [row.tcpVersion]);
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.ProtocolPublishRePublish}/${row.publishId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.visible = false;
        });
      });
    },
    getTopicMsg() {
      const reqData = {
        ...this.formSearch,
        protocolCode: this.editModel.protocolCode,
        tcpVersion: this.editModel.tcpVersion,
      };
      this.$getJSON(apis.ProtocolPublishTopicPage, reqData).then((res) => {
        this.topicMsg = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTopicMsg();
    },
  },
  created() {},
  mounted() {
    this.getPublishRecord();
  },
};
</script>

<style lang="scss" scoped>
.publish-record-dialog {
  .dialog-body {
    padding-top: 0 !important;
  }
  .href {
    text-decoration: underline;
    color: #0d9ae0;
    cursor: pointer;
  }
  .topic-code {
    color: inherit !important;
  }
  .box-content {
    display: flex;
    height: 500px;

    > .content {
      display: flex;
      flex-direction: column;
    }

    .publish-record {
      padding-right: 10px;
      padding-top: 62px;
    }

    .topic-info {
      padding-left: 10px;
    }

    .publish-record {
      width: 430px;
    }

    .topic-info {
      flex: 1;
      width: 0;
    }
  }
}
</style>
